import * as React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";

const imageBoxSx = {
  minWidth: { xs: "110px", md: "110px" }, // Responsive width
  maxWidth: { xs: "110px", md: "110px" },
  height: { xs: "165px", md: "165px" }, // Responsive height
  boxShadow: {
    xs: "0px 0px 10px 5px rgba(255, 255, 255, 0.1)", // Smaller shadow on mobile
    md: "0px 0px 20px 10px rgba(255, 255, 255, 0.1)", // Larger shadow on desktop
  },
  marginTop: { xs: "3px", md: "7px" },
  marginBottom: { xs: "3px", md: "5px" },
  borderRadius: "2px",
};

export const FilmTileLoading: React.FC = () => {
  const theme = useTheme();

  const renderImageSkeleton = () => {
    return (
      <Box
        sx={{
          ...imageBoxSx,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Skeleton variant="rectangular" sx={{ width: 110, height: 165 }} />
      </Box>
    );
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: { xs: 3, md: 5 },
          borderBottom: `2px solid ${theme.palette.divider}`,
          maxWidth: "80%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            minHeight: { xs: "165px", md: "165px" },
          }}
        >
          {renderImageSkeleton()}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              marginLeft: { xs: 2, md: 3 },
              flexGrow: 1,
            }}
          >
            <Skeleton width="100%" height={30} />
            <Skeleton width="100%" height={100} />
          </Box>
        </Box>
      </Box>
    </div>
  );
};
